export default {
  translations: {
    'Try it out': 'Try it out',
    'Preview not available': 'Preview not available',
    'New Board': 'New Board',
    'Import from .zip': 'Import from .zip',
    'Importing...': 'Importing...',
    'Failed to import board.': 'Failed to import board.',
    'Create board on the tablet?': 'Create board on the tablet?',
    'Import board to the tablet?': 'Import board to the tablet?',
    "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.":
      "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.",
    'Board title': 'Board title',
    'Enter a title for the board': 'Enter a title for the board',
    'Card language': 'Card language',
    'Creating...': 'Creating...',
    'Failed to create board.': 'Failed to create board.',
    'Choose an image from the bank, generate one with AI or upload your own.':
      'Choose an image from the bank, generate one with AI or upload your own.',
    'Used for the symbol bank and speech (text-to-speech) of this board.':
      'Used for the symbol bank and speech (text-to-speech) of this board.',
    'How do you want to start?': 'How do you want to start?',
    'Blank board': 'Blank board',
    'Start with tutorial': 'Start with tutorial',
    'Create a board from scratch': 'Create a board from scratch',
    'Learn the studio with a ready-made board':
      'Learn the studio with a ready-made board',
    'Is this your first time creating boards?':
      'Is this your first time creating boards?',
    "Don't show this again": "Don't show this again",
    'Choose a title for your board': 'Choose a title for your board',
    'Preview board': 'Board preview',
    'Displayed text': 'Displayed text',
    'Back and edit': 'Back and edit',
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large',
    // Mesmo valor usado nas configurações (defaultNS)
    login: {
      welcome: 'Welcome to Livox!',
      error:
        'It is not possible to log in with the information provided. Incorrect mail and/or password(s).',
      inactive_customer:
        'Your account has been deactivated. Please contact support for assistance.',
    },
    payment: {
      purchaseFor: 'Purchase for',
      supportEmail: 'Contact email',
      onlyPortugueseAvailable:
        'Payment is only available in Portuguese at the moment.',
      youHaveActiveSubscriptions: 'You have active subscriptions.',
      viewMyAssessments: 'View in My Assessments',
    },
    pm: {
      cards: 'Cards',
      paymentMethod: 'Payment Methods',
      manageYourPayment:
        'Manage your payment information. To view yourmonthly subscription details, go to your Subscriptions.',
      defaultPayment: 'Default Payment',
      setAsDefault: 'Set as default',
      addCard: 'Add card',
      addBoleto: 'Add boleto',
      creditCard: 'Credit Card',
      boleto: 'Boleto',
      add: 'Add',
      boletos: 'Boletos',
    },
    paymentRegister: {
      title: 'Register to purchase Livox',
      orLoginWithAccount: 'Already have an account?',
      loginToComplete: 'Log in to complete your purchase',
      orRegisterNew: 'Or register to create a new account',
      email: 'Email',
      fullName: 'Full Name',
      emailRequired: 'Email is required',
      fullNameRequired: 'Full name is required',
      enterFullName: 'Enter your full name',
      codeInfo:
        'You will receive a 6-digit code by email. The code is valid for 15 minutes.',
      sending: 'Sending...',
      sendCode: 'Send activation code',
      codeSentTo: 'Code sent to',
      activationCode: 'Activation code',
      resendCode: 'Resend code',
      continue: 'Continue',
      validating: 'Validating...',
      codeValid: 'Code is valid.',
      changeEmail: 'Change email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      enterPassword: 'Enter your password',
      confirmYourPassword: 'Confirm your password',
      passwordRequired: 'Password is required',
      confirmPasswordRequired: 'Please confirm your password',
      activating: 'Activating...',
      activateAccount: 'Activate account',
      back: 'Back',
      accountExists: 'Account already exists. Please log in to continue.',
      codeSentSuccess:
        'A 6-digit activation code has been sent to your email. Valid for 15 minutes.',
      newCodeSent: 'A new code has been sent to your email',
      somethingWrong: 'Something went wrong',
      resendFailed: 'Failed to resend code',
      passwordsDontMatch: "Passwords don't match",
      activationFailed: 'Activation failed',
      accountActivated: 'Account activated successfully!',
      codeExpired:
        'Activation code expired or invalid. Please request a new one.',
      invalidCode: 'Invalid activation code.',
      accountAlreadyActive: 'Account already active. Please log in.',
      rateLimit: 'Please wait a moment before requesting a new code.',
      passwordRequirements:
        'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters',
      holderAlreadyRegistered:
        'A holder is already registered with this email. Please log in to the portal.',
      holderAlreadyRegisteredTitle: 'Holder already registered',
      holderAlreadyRegisteredMessage:
        'A holder is already registered with this email. Please log in to the portal to access your account.',
      holderAlreadyRegisteredMessageWithEmail:
        'A holder is already registered with this email. The email {{email}} has already been created as a holder. Please log in to the portal to access your account.',
      tokenInvalidOrExpired: 'Your token is invalid or has expired',
      goToLogin: 'Go to login',
    },
    cancel: 'Cancel',
    cpfOrCnpj: 'CPF or CNPJ',
    Role: 'Role',
    Often: 'Often',
    Sometimes: 'Sometimes',
    Never: 'Never',
    Date: 'Date',
    CGQ: 'CGQ',
    VIQ: 'VIQ',
    AUQ: 'AUQ',
    OLQ: 'OLQ',
    BHQ: 'BHQ',
    Overall: 'Overall',
    Actions: 'Actions',
    'Holder Info': 'Holder Info',
    Loading: 'Loading',
    Profile: 'Profile',
    Comments: 'Comments',
    'View Branch': 'View Branch',
    'Add License to Branch': 'Add License to Branch',
    'Create Board': 'Create Board',
    'Review Publication': 'Review Publication',
    Creator: 'Creator',
    'Board History': 'Board History',
    'Change Customers to Support Area': 'Change Customers to Support Area',
    'Change Users to Support Area': 'Change Users to Support Area',
    'Change Licenses to Branch': 'Change Licenses to Branch',
    'Tablet code': 'Tablet code',
    Back: 'Back',
    'Livox Store': 'Livox Store',
    Communication: 'Communication',
    Leisure: 'Leisure',
    Feelings: 'Feelings',
    Hospital: 'Hospital',
    Social: 'Social',
    'Daily Life': 'Daily Life',
    Foods: 'Foods',
    School: 'School',
    Education: 'Education',
    Literacy: 'Literacy',
    Grammar: 'Grammar',
    Geography: 'Geography',
    Science: 'Science',
    History: 'History',
    Math: 'Math',
    Biology: 'Biology',
    Fun: 'Fun',
    Stories: 'Stories',
    Games: 'Games',
    Game: 'Games',
    Memory: 'Memory',
    'Questions and Answers': 'Questions and Answers',
    'Popular Items': 'Popular Items',
    'See more': 'See more',
    Code: 'Code',
    'Last Modified': 'Last Modified',
    'Upload from .zip': 'Upload from .zip',
    'Cover Art': 'Cover Art',
    Title: 'Title',
    Description: 'Description',
    Categories: 'Categories',
    Submitter: 'Submitter',
    'Published at': 'Published at',
    View: 'View',
    'Pending Approval': 'Pending Approval',
    'Holders Search': 'Holders Search',
    'Filter Status': 'Filter Status',
    'Audit Licenses': 'Audit Licenses',
    'No Device': 'No Device',
    'Livox Version': 'Livox Version',
    'Android Version': 'Android Version',
    'Last Validation At': 'Last Validation At',
    Manage: 'Manage',
    Store: 'Store',
    Books: 'Books',
    'Sign up': 'Sign up',
    Talk: 'Talk',
    Learn: 'Learn',
    Admin: 'Admin',
    'Store Admin': 'Store Admin',
    'Discover new boards, games and stories':
      'Discover new boards, games and stories',
    'Search in store': 'Search in store',
    'Search boards, games, stories...': 'Search boards, games, stories...',
    'Recommended content': 'Recommended content',
    'Featured boards': 'Featured boards',
    'New content': 'New content',
    'Featured creators': 'Featured creators',
    'My content': 'My content',
    'My Boards': 'My Boards',
    'My Portal Boards': 'My Portal Boards',
    'Welcome {{name}}, you have {{count}} licenses':
      'Welcome {{name}}, you have {{count}} licenses',
    'Publish one of your boards to share it with the Livox community.':
      'Publish one of your boards to share it with the Livox community.',
    'Welcome {{name}}, you have {{count}} users':
      'Welcome {{name}}, you have {{count}} users',
    'A-Z': 'A-Z',
    Size: 'Size',
    Studio: 'Studio',
    Favorites: 'Favorites',
    Keyboard: 'Keyboard',
    Import: 'Import',
    Assign: 'Assign',
    'Unable to load your content': 'Unable to load your content',
    'Import board': 'Import board',
    'Created by': 'Created by',
    'Board tags': 'Board tags',
    'No tags': 'No tags',
    'Report content': 'Report content',
    'Report reason': 'Report reason',
    Report: 'Report',
    'Report sent': 'Report sent',
    'Failed to send report': 'Failed to send report',
    'Offensive content': 'Offensive content',
    'Inappropriate language': 'Inappropriate language',
    'Sexual or inappropriate content': 'Sexual or inappropriate content',
    Violence: 'Violence',
    'Hate speech': 'Hate speech',
    'Spam or advertising': 'Spam or advertising',
    'Copyright infringement': 'Copyright infringement',
    'Duplicate content': 'Duplicate content',
    'Off-topic content': 'Off-topic content',
    'Exposed personal data': 'Exposed personal data',
    'Content deleted': 'Content deleted',
    'Failed to delete content': 'Failed to delete content',
    'Sending...': 'Sending...',
    'Sort by': 'Sort by',
    Downloads: 'Downloads',
    'Livox Community': 'Livox Community',
    'Total downloads': 'Total downloads',
    'Community content': 'Community content',
    Follow: 'Follow',
    Following: 'Following',
    'View content': 'View content',
    Community: 'Community',
    Logout: 'Logout',
    'No description': 'No description',
    'No Title': 'No Title',
    New: 'New',
    'New Releases': 'New Releases',
    'Top Rated': 'Top Rated',
    'See all': 'See all',
    'Browse by category': 'Browse by category',
    'No content found': 'No content found',
    'Try adjusting your filters': 'Try adjusting your filters',
    'Go to slide': 'Go to slide',
    'Back to Store': 'Back to Store',
    'Loading board...': 'Loading board...',
    'No description provided': 'No description provided',
    stars: 'stars',
    votes: 'votes',
    Rate: 'Rate',
    'Be the first to rate': 'Be the first to rate',
    'In progress': 'In progress',
    'Tablet preview': 'Tablet preview',
    'Tablet preview coming soon': 'Tablet preview coming soon',
    Republish: 'Republish',
    Filters: 'Filters',
    Clear: 'Clear',
    Speak: 'Speak',
    Previous: 'Previous',
    'Previous page': 'Previous page',
    'Next page': 'Next page',
    'Remove last': 'Remove last',
    Fullscreen: 'Fullscreen',
    'Exit fullscreen': 'Exit fullscreen',
    'Go to Portal': 'Go to Portal',
    'Sign in': 'Sign in',
    'Sign out': 'Sign out',
    'Open menu': 'Open menu',
    'Close menu': 'Close menu',
    Menu: 'Menu',
    'Publication not available': 'This publication is not available',
    'All languages': 'All languages',
    'Switch to dark mode': 'Switch to dark mode',
    'Switch to light mode': 'Switch to light mode',
    'Toggle theme': 'Toggle theme',
    'Sign in to download': 'Sign in to download',
    'Sign in to rate': 'Sign in to rate',
    'Author not found': 'Author not found',
    'Unnamed author': 'Unnamed author',
    publication: 'publication',
    publications: 'publications',
    'Boards by this author': 'Boards by this author',
    'Link copied to clipboard': 'Link copied to clipboard',
    'Failed to download content': 'Failed to download content',
    'Thanks for your vote!': 'Thanks for your vote!',
    'Failed to send vote': 'Failed to send vote',
    'Content promoted': 'Content promoted',
    'View profile': 'View profile',
    'Page Size': 'Page Size',
    'Licenses Search': 'Licenses Search',
    Licenses: 'Licenses',
    'Support Areas': 'Support Areas',
    'Stripe Information': 'Stripe Information',
    'No information': 'No information',
    Canceled: 'Canceled',
    past_due: 'Past due',
    active: 'Active',
    Customers: 'Customers',
    'Livox Users': 'Livox Users',
    'Distributor Totals': 'Distributor Totals',
    'Portal Administration': 'Portal Administration',
    'My Devices': 'My Devices',
    'My Livox Users': 'My Livox Users',
    'My Licenses': 'My Licenses',
    'My Authorized Users': 'My Authorized Users',
    'New Customer': 'New Customer',
    'Notify Customer': 'Notify Customer',
    'New Branch': 'New Branch',
    'New Portal User': 'New Portal User',
    'Install Key': 'Install Key',
    'License Key': 'License Key',
    'New License': 'New License',
    'New Registration Link': 'New Registration Link',
    'All Livox users': 'All Livox users',
    Home: 'Home',
    Customer: 'Customer',
    'My Branches': 'My Branches',
    Branches: 'Branches',
    'Last Name': 'Last Name',
    Gender: 'Gender',
    Age: 'Age',
    Evaluations: 'Evaluations',
    'Last Evalution': 'Last Evalution',
    License: 'License',
    Key: 'Key',
    Status: 'Status',
    City: 'City',
    State: 'State',
    Country: 'Country',
    Available: 'Available',
    Active: 'Active',
    Inactive: 'Inactive',
    Phone: 'Phone',
    'First Name': 'First Name',
    'Device Name': 'Device Name',
    Version: 'Version',
    'Remove Device': 'Remove Device',
    User: 'User',
    Contact: 'Contact',
    Diagnosis: 'Diagnosis',
    Device: 'Device',
    'Delete User': 'Delete User',
    'My Users': 'My Users',
    Expire: 'Expire',
    Support: 'Support',
    Dates: 'Dates',
    'Expiration Date': 'Expiration Date',
    'Support Date': 'Support Date',
    'Click to edit expiration date': 'Click to edit expiration date',
    'Click to edit support date': 'Click to edit support date',
    'Expiration date updated successfully':
      'Expiration date updated successfully',
    'Support date updated successfully': 'Support date updated successfully',
    'Failed to update expire date': 'Failed to update expire date',
    'Failed to update support date': 'Failed to update support date',
    'MAC Address': 'MAC Address',
    'Device Version': 'Device Version',
    Name: 'Name',
    'Num. Licenses': 'Num. Licenses',
    Activated: 'Activated',
    Inactivated: 'Inactivated',
    Email: 'Email',
    'My Auth Users': 'My Auth Users',
    Holder: 'Holder',
    'Customer Licenses': 'Customer Licenses',
    Type: 'Type',
    Distribution: 'Distribution',
    Language: 'Language',
    Reseller: 'Reseller',
    Text: 'Text',
    'Number of Devices': 'Number of Devices',
    'Lifetime License': 'Lifetime License',
    Address: 'Address',
    Zipcode: 'Zipcode',
    Neighborhood: 'Neighborhood',
    'Contact Email': 'Contact Email',
    'Confirm Contact Email': 'Confirm Contact Email',
    'First name': 'First name',
    'Last name': 'Last name',
    Group: 'Group',
    Password: 'Password',
    Male: 'Male',
    Female: 'Female',
    'My Portal Users': 'My Portal Users',
    'Edit Profile': 'Edit Profile',
    'Change Password': 'Change Password',
    Register: 'Register',
    'I forgot my password': 'I forgot my password',
    Account: 'Account',
    'No results': 'No results',
    'Customers Search': 'Customers Search',
    Search: 'Search',
    'Search by name or email': 'Search by name or email',
    'Tree view': 'Tree view',
    'Table view': 'Table view',
    Download: 'Download',
    'Registration Link': 'Registration Link',
    Page: 'Page',
    of: 'of',
    results: 'results',
    'View Branches': 'View Branches',
    'View Users': 'View Users',
    Cancel: 'Cancel',
    Create: 'Create',
    'Branch Name': 'Branch Name',
    'Confirm Password': 'Confirm Password',
    'Customer Branches': 'Customer Branches',
    'My Evaluations': 'My Evaluations',
    'Livox User': 'Livox User',
    'Add Branch': 'Add Branch',
    'Distributor Customers': 'Distributor Customers',
    'New Support Area': 'New Support Area',
    'Assign Users': 'Assign Users',
    'Assign Customers': 'Assign Customers',
    Dashboard: 'Dashboard',
    'Unique users by day': 'Unique users by day',
    'Users by language': 'Users by language',
    'Users by country': 'Users by country',
    Devices: 'Devices',
    'Manage my devices': 'Manage my devices',
    News: 'News',
    'Read more': 'Read more',
    'Total Licenses': 'Total Licenses',
    'Paid Licenses': 'Paid Licenses',
    'Free Licenses': 'Donated Licenses',
    'Distributor Stats': 'Distributor Stats',
    Users: 'Users',
    Remove: 'Remove',
    Evaluate: 'Evaluate',
    'Cognitive Evaluation': 'Cognitive Evaluation',
    'Recognizes images': 'Recognizes images',
    'Notion of cause and effect': 'Notion of cause and effect',
    'Has notion of body awareness': 'Has notion of body awareness',
    'Has symbolic representation': 'Has symbolic representation',
    'Makes choices': 'Makes choices',
    Literate: 'Literate',
    'Auditory Agnosia': 'Auditory Agnosia',
    'Cow mooing': 'Cow mooing',
    'Chicken clucking': 'Chicken clucking',
    'Dog barking': 'Dog barking',
    Doorbell: 'Doorbell',
    Sirens: 'Sirens',
    'Visual Agnosia': 'Visual Agnosia',
    Dog: 'Dog',
    Cat: 'Cat',
    Bird: 'Bird',
    House: 'House',
    Banana: 'Banana',
    Grapes: 'Grapes',
    Pineapple: 'Pineapple',
    Watermelon: 'Watermelon',
    Telephone: 'Telephone',
    Car: 'Car',
    Shoe: 'Shoe',
    Ball: 'Ball',
    'Visual Oral Language': 'Visual Oral Language',
    'Where is the ball?': 'Where is the ball?',
    'Where is the doll?': 'Where is the doll?',
    'Are you at home?': 'Are you at home?',
    'What is the name of your mother?': 'What is the name of your mother?',
    'What is your name?': 'What is your name?',
    'Does he/she know his/her birthday?': 'Does he/she know his/her birthday?',
    'Does he/she know his/her name?': 'Does he/she know his/her name?',
    'Does he/she orient to date/time?': 'Does he/she orient to date/time?',
    'Can he/she follow one step directions?':
      'Can he/she follow one step directions?',
    'Can he/she follow two step directions?':
      'Can he/she follow two step directions?',
    'Behavior Evaluation': 'Behavior Evaluation',
    'Does he/she bite?': 'Does he/she bite?',
    'Does he/she hit his/her head on the wall?':
      'Does he/she hit his/her head on the wall?',
    'Does he/she understand feelings?': 'Does he/she understand feelings?',
    'Does he/she sleep well?': 'Does he/she sleep well?',
    General: 'General',
    'Does he/she cry?': 'Does he/she cry?',
    'Does he/she have temper tantrums?': 'Does he/she have temper tantrums?',
    'Is he/she aggressive?': 'Is he/she aggressive?',
    'Does he/she eat well?': 'Does he/she eat well?',
    'Does he/she run from one place to another?':
      'Does he/she run from one place to another?',
    'Does he/she focus in an activity?': 'Does he/she focus in an activity?',
    'Does he/she play with other children?':
      'Does he/she play with other children?',
    'Does he/she have a hard time to sleep?':
      'Does he/she have a hard time to sleep?',
    'Does he/she like to be alone?': 'Does he/she like to be alone?',
    'Does he/she demonstrate joint attention?':
      'Does he/she demonstrate joint attention?',
    'Does he/she scream?': 'Does he/she scream?',
    'Is he/she hypersensitive to sensory stimuli?':
      'Is he/she hypersensitive to sensory stimuli?',
    'Is he/she unaware to sensory stimuli?':
      'Is he/she unaware to sensory stimuli?',
    Holders: 'Holders',
    Purcharse: 'Purcharse',
    Edit: 'Edit',
    Delete: 'Delete',
    'E-mail': 'E-mail',
    'Full Name': 'Full Name',
    'Phone Number': 'Phone Number',
    Save: 'Save',
    Undo: 'Undo',
    Publish: 'Publish',
    'New Item': 'New Item',
    Attributes: 'Attributes',
    'Display Text': 'Text to be displayed',
    'Spoken Phrase': 'Text to be spoken',
    'Expand image on click': 'Expand image on click',
    Colors: 'Colors',
    Pictures: 'Pictures',
    'Search a symbol': 'Search a symbol',
    'Field Changed': 'Field Changed',
    'Old Value': 'Old Value',
    'New Value': 'New Value',
    'License History': 'License History',
    Branch: 'Branch',
    'Evaluation Date': 'Evaluation Date',
    'Branch Licenses': 'Branch Licenses',
    'Add Licenses to Branch': 'Add Licenses to Branch',
    Confirm: 'Confirm',
    Close: 'Close',
    'Livox version distribution': 'Livox version distribution',
    'Expires in': 'Expires in',
    'Support ends': 'Support ends',
    available: 'available',
    'Android OS distribution': 'Android OS distribution',
    likes: 'likes',
    downloads: 'downloads',
    'Reviewed at': 'Reviewed at',
    Comment: 'Comment',
    Pending: 'Pending',
    Approved: 'Approved',
    Archived: 'Archived',
    Accept: 'Accept',
    Reject: 'Reject',
    Reason: 'Reason',
    Rejected: 'Rejected',
    'Create License Registration Link': 'Create License Registration Link',
    'Create separate install keys': 'Create separate install keys',
    'Log Out': 'Log Out',
    'Evaluate Livox User': 'Evaluate Livox User',
    Billing: 'Billing',
    'Acquire Livox': 'Acquire Livox',
    'You are about to purchase the best alternative comunication app in the world!':
      'You are about to purchase the best alternative communication app in the world!',
    '1. Select a Plan': '1. Select a Plan',
    BASIC: 'BASIC',
    'Up to 3 users': 'Up to 3 users',
    'Smart Scan': 'Smart Scan',
    'IntelliTouch - Touch Correction': 'IntelliTouch - Touch Correction',
    'Virtual keyboard': 'Virtual keyboard',
    'Stock Images (20,000 images)': 'Stock Images (20,000 images)',
    'Creation of pedagogical content': 'Creation of pedagogical content',
    'Voice, text and image customization':
      'Voice, text and image customization',
    'Content transfer between tablets': 'Content transfer between tablets',
    '/ month': '/ month',
    'on a yearly plan': 'on a yearly plan',
    PLUS: 'PLUS',
    'Recommended for families': 'Recommended for families',
    'New Features Update': 'New Features Update',
    'Trigger Control': 'Trigger Control',
    'Livox control with the blink of an eye':
      'Livox control with the blink of an eye',
    'Artificially Intelligent Item Recommendations Based on Time and Location':
      'Artificially Intelligent Item Recommendations Based on Time and Location',
    PRO: 'PRO',
    'Recommended for professionals!': 'Recommended for professionals!',
    'UNLIMITED Users': 'UNLIMITED Users',
    "Complete assessment and content tool to track users' progress with Livox (patients or students)":
      "Complete assessment and content tool to track users' progress with Livox (patients or students)",
    '2. Select a payment plan': '2. Select a payment plan',
    monthly: 'monthly',
    quarterly: 'quarterly',
    '% off': '% off',
    yearly: 'yearly',
    '3. Confirm the value': '3. Confirm the value',
    'per month': 'per month',
    'Proceed with the checkout': 'Proceed with the checkout',
    'Select a Plan': 'Select a Plan',
    Continue: 'Continue',
    'Get Livox': 'Get Livox',
    'Select a Plan - Livox Portal': 'Select a Plan - Livox Portal',
    '1. Confirm your Plan': '1. Confirm your Plan',
    '1. Choose your billing period': '1. Choose your billing period',
    '2. Choose your plan': '2. Choose your plan',
    '1. Choose your plan': '1. Choose your plan',
    '3. Confirm your selection': '3. Confirm your selection',
    '2. Confirm your selection': '2. Confirm your selection',
    Plan: 'Plan',
    'Save more': 'Save more',
    'Billing period': 'Billing period',
    'Secure checkout': 'Secure Payment',
    'Your payment information is encrypted and secure.':
      'Your payment information is encrypted and secure.',
    'Please wait for your profile to load, or refresh the page.':
      'Please wait for your profile to load, or refresh the page.',
    'Powered by Stripe': 'Powered by Stripe',
    '3. Confirm the plan': '3. Confirm the plan',
    Checkout: 'Checkout',
    processing: 'Processing...',
    tryAgainIn: 'Try again in {{seconds}}s',
    'per year': 'per year',
    Change: 'Change',
    'per quarter': 'per quarter',
    'Cardholder Name': 'Cardholder Name',
    'Street address': 'Street address',
    'Apartment / Suite / Unit / Building':
      'Apartment / Suite / Unit / Building',
    'Billing Address': 'Billing Address',
    'Payment Info': 'Payment Info',
    'Credit or debit card': 'Credit or debit card',
    'Credit card info secured by': 'Credit card info secured by',
    Success: 'Success',
    'Upload from .zip file here': 'Upload from .zip file here',
    'Published Title': 'Published Title',
    'Publish Content': 'Publish Content',
    'Cover Image': 'Cover Image',
    'Upload Image': 'Upload Image',
    Buy: 'Buy',
    Boards: 'Boards',
    'Thanks for purcharsing Livox': 'Thanks for purchasing Livox',
    'Thanks for purchasing Livox': 'Thanks for purchasing Livox',
    'Your payment has been processed successfully.':
      'Your payment has been processed successfully.',
    'Payment successful': 'Payment successful',
    'Purchase summary': 'Purchase summary',
    'What happens next?': 'What happens next?',
    'Need help?': 'Need help?',
    'Contact support': 'Contact support',
    'We are processing your payment, a receipt will be sent to':
      'We are processing your payment, a receipt will be sent to',
    'with instructions on how activate Livox.':
      'with instructions on how activate Livox.',
    'If you have any question / issues': 'If you have any question / issues',
    'contact our support.': 'contact our support.',
    Deleted: 'Deleted',
    'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.':
      'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.',
    'You have successfully registered, Please return to the tablet to proceed.':
      'You have successfully registered, Please return to the tablet to proceed.',
    'Validation notEmpty on coverImage failed':
      'Please add a cover image to the publication!',
    'You are not logged in. Create your account to see more of this content':
      'You are not logged in. Create your account to see more of this content',
    'Buy Livox': 'Buy Livox',
    'Select your plan and payment method to get started.':
      'Select your plan and payment method to get started.',
    'payment.pageDescription':
      'Select your plan and payment method to complete your purchase.',
    'payment.propaganda':
      'You are about to purchase the best alternative communication app in the world!',
    'payment.activeSubscriptionsCount': '{{count}} active subscription(s)',
    'payment.youHaveLicenses': 'You have active licenses.',
    'payment.viewLicensesHere': 'View your licenses here',
    'payment.youHaveActiveSubscriptions': 'You have active subscriptions.',
    'payment.viewMyAssessments': 'View in My Assessments',
    'payment.viewMySubscriptions': 'View in My Subscriptions',
    'payment.onlyPortugueseTitle': 'Payment unavailable',
    'payment.onlyPortugueseAvailable':
      'Payment is only available in Portuguese at the moment.',
    'payment.blockedInBrazilTitle': 'Payment unavailable in your region',
    'payment.blockedInBrazil':
      'Online payment is not available for access from Brazil.',
    'payment.blockedContactTitle': 'Contact us:',
    'payment.blockedContactBrazil':
      'Brazil\n+55 81 97108 3009 (Phone and WhatsApp)\ncontato@livox.com.br\nAvenida Fagundes Varela, 950, LJ 15, CXP 1776, Jardim Atlântico, Olinda-Pe, Brasil, CEP: 53140-080',
    'payment.blockedContactUS':
      'U.S\n+1 (407) 449-6391\ncarlos@livox.com.br\nGrand National Drive, suite 128, Orlando, FL',
    'payment.blockedContactJordan':
      'Jordan\n00962796870058\nala.alramahi@gmail.com',
    'payment.noLicensesEncourage':
      "You don't have any licenses. Purchase now to get started with Livox!",
    'Your boleto has been generated. Please complete the payment within the due date.':
      'Your boleto has been generated. Please complete the payment within the due date.',
    'Back to Home': 'Back to Home',
    'Please enter a valid CPF or CNPJ': 'Please enter a valid CPF or CNPJ',
    'An error occurred': 'An error occurred',
    'Payment failed': 'Payment failed',
    'Please fill in all required fields': 'Please fill in all required fields',
    Media: 'Media',
    'Upload an image or video': 'Upload an image or video',
    'No image': 'No image',
    'Welcome to your boards page': 'Welcome to your boards page',
    'Assistive Tecnology': 'Assistive Tecnology',
    '1. Create': '1. Create',
    'To get started use the Livox Studio to create cards, upload images, music and videos':
      'To get started use the Livox Studio to create cards, upload images, music and videos',
    '2. Publish': '2. Publish',
    'Submit you content to be published in the store':
      'Submit you content to be published in the store',
    '3. Get feedback': '3. Get feedback',
    'Receive feedback and satisfaction on seeing your content being used all around the globe!':
      'Receive feedback and satisfaction on seeing your content being used all around the globe!',
    'Livox Portal': 'Livox Portal',
    'A content store made for you!': 'A content store made for you!',
    'The best portal of assistive technologies in the world!':
      'The best portal of assistive technologies in the world!',
    'Learn More': 'Learn More',
    'Recent Items': 'Recent Items',
    by: 'by',
    'Untitled Content': 'Untitled Content',
    'Loading...': 'Loading...',
    'Click here to add a title': 'Click here to add a title',
    'Portuguese (BR)': 'Portuguese (BR)',
    English: 'English',
    Arabic: 'Arabic',
    German: 'German',
    'No boards found': 'No boards found',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this device?':
      'Removing this device will make the user log out of the app. Are you sure you want to remove this device?',
    'New User': 'New User',
    'Login as another user': 'Login as another user',
    Technical: 'Technical',
    Pedagogical: 'Pedagogical',
    Results: 'Results',
    'Top Rated Items': 'Top Rated Items',
    'Back to Livox Portal': 'Back to Livox Portal',
    'No Categories': 'No Categories',
    Author: 'Author',
    'No votes yet': 'No votes yet',
    'Rate this content': 'Rate this content',
    'You must be logged in to vote on this content!':
      'You must be logged in to vote on this content!',
    'Go to Livox Store': 'Go to Livox Store',
    'Go to Play Store': 'Go to Play Store',
    'Sign Up': 'Sign Up',
    Login: 'Login',
    'Log In': 'Log In',
    'License Availability': 'License Availability',
    'My Profile': 'My Profile',
    'No description available': 'No description available',
    Publications: 'Publications',
    'User Profile': 'User Profile',
    'New user': 'New user',
    'Livox Users Growth': 'Livox Users Growth',
    'Users Disability Distribution': 'Users Disability Distribution',
    'Contact us': 'Contact us',
    'Support Type': 'Support Type',
    Subject: 'Subject',
    Message: 'Message',
    Send: 'Send',
    'License Distribution': 'License Distribution',
    'Manage my licenses': 'Manage my licenses',
    'Show From': 'Show From',
    'Only my branch': 'Only my branch',
    'All Branches': 'All Branches',
    'Last Validation Date': 'Last Validation Date',
    'Device ID': 'Device ID',
    'About you': 'About you',
    'No publications yet': 'No publications yet',
    'No description available.': 'No description available.',
    'Remove this livox user? ': 'Remove this livox user? ',
    'Users by city': 'Users by city',
    'Create new customer': 'Create new customer',
    'Boards Search': 'Boards Search',
    'Add a branch to': 'Add a branch to',
    'Edit Branch': 'Edit Branch',
    'Edit Customer': 'Edit Customer',
    'Delete Branch': 'Delete Branch',
    'Create Branch Administrator': 'Create Branch Administrator',
    'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?':
      'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?',
    'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.':
      'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.',
    'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.':
      'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.',
    'Are you sure you want to delete this branch?':
      'Are you sure you want to delete this branch?',
    'Are you sure you want to delete branch':
      'Are you sure you want to delete branch',
    'Delete all users of this customer and all its branches.':
      'Delete all users of this customer and all its branches.',
    'Delete all licenses of this customer and all its branches.':
      'Delete all licenses of this customer and all its branches.',
    'Delete all Livox users of this customer and all its branches.':
      'Delete all Livox users of this customer and all its branches.',
    'Delete all holders of this customer and all its branches.':
      'Delete all holders of this customer and all its branches.',
    'Transfer all users from this branch and its child branches to the parent branch.':
      'Transfer all users from this branch and its child branches to the parent branch.',
    'Transfer all licenses from this branch and its child branches to the parent branch.':
      'Transfer all licenses from this branch and its child branches to the parent branch.',
    'Remove this branch and its child branch structure.':
      'Remove this branch and its child branch structure.',
    'Reset Password': 'Reset Password',
    'years ago': 'years ago',
    'months ago': 'months ago',
    'days ago': 'days ago',
    'hours ago': 'hours ago',
    'minutes ago': 'minutes ago',
    'seconds ago': 'seconds ago',
    'Livox app is outdated on this device':
      'Livox app is outdated on this device',
    'Sort By...': 'Sort By...',
    'Device Android Id': 'Device Android Id',
    Saved: 'Saved',
    'Saving...': 'Saving...',
    'Error! Please refresh the page.': 'Error! Please refresh the page.',
    Review: 'Review',
    'Upload an audio or video': 'Upload an audio or video',
    'All Languages': 'All Languages',
    Portuguese: 'Portuguese',
    "By clicking 'Publish' you are agreeing that you have read and accepted our":
      "By clicking 'Publish' you are agreeing that you have read and accepted our",
    'terms of use': 'terms of use',
    'Add a shortcut...': 'Add a shortcut...',
    ExampleShortcut: 'Example: "What do you want to eat?" on a Food board.',
    'Create voice commands to open this board on Livox app!':
      'Activate Livox Natural Conversation by saying one of your keywords. Then, you can show the current board when you speak one of the shortcuts below',
    Shortcuts: 'Shortcuts',
    'NEW!': 'NEW!',
    'Uploading...': 'Uploading...',
    'Processing files...': 'Processing files... Please wait for completion.',
    'The file you uploaded is too large.':
      'The file you uploaded is too large.',
    'Error: File too large': 'Error: File too large',
    'Error: Sorry we just encoutered an unexpected error, please try again':
      'Error: Sorry we just encoutered an unexpected error, please try again',
    'Error: The zip file appears to be corrupted or is not a Livox content':
      'Error: The zip file appears to be corrupted or is not a Livox content',
    'Are you sure you want to delete this content?':
      'Are you sure you want to delete this content?',
    'Error: Invalid content, please make sure that the file being uploaded is a .zip file':
      'Error: Invalid content, please make sure that the file being uploaded is a .zip file',
    'Sorry we just encoutered an unexpected error, please try again':
      'Sorry we just encoutered an unexpected error, please try again',
    'Get Started': 'Get Started',
    'Record a new shortcut via voice': 'Record a new shortcut via voice',
    'You have blocked this website of using the Microphone.':
      'You have blocked this website of using the Microphone.',
    "Couldn't detect speech, please check your microphone settings.":
      "Couldn't detect speech, please check your microphone settings.",
    'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below':
      'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below',
    'Error while recording shorcut, please try again':
      'Error while recording shorcut, please try again',
    Features: 'Features',
    'Voice Shortcuts': 'Voice Shortcuts',
    'Add shortcuts to this folder': 'Add shortcuts to this folder',
    shortcuts: 'shortcuts',
    'You have pending reviews': 'You have pending reviews',
    'No pending reviews': 'No pending reviews',
    'Admin Portal': 'Admin Portal',
    'Log out': 'Log out',
    'Zip Overwrite': 'Zip Overwrite',
    Share: 'Share',
    'Used Licenses': 'Used Licenses',
    'Last Registered Activity': 'Last Registered Activity',
    'Interactions by time of day': 'Interactions by time of day',
    'Avg. Interactions / User': 'Avg. Interactions / User',
    Featured: 'Featured',
    'Promoted Content': 'Promoted Content',
    'Rate this': 'Rate this',
    Promote: 'Promote',
    'Your rating': 'Your rating',
    Play: 'Play',
    'Back to Edit': 'Back to Edit',
    Next: 'Next',
    'Inside items': 'Inside items',
    Regular: 'Regular',
    'Book Mode': 'Book Mode',
    Fixed: 'Fixed',
    System: 'System',
    Rows: 'Rows',
    Collumns: 'Collumns',
    Display: 'Display',
    'Page Mode': 'Page Mode',
    'Text Size': 'Text Size',
    Print: 'Print',
    'This dashboard is made with aggregated data across all licenses':
      'This dashboard is made with aggregated data across all licenses',
    ' assigned to your user': ' assigned to your user',
    'view licenses': 'view licenses',
    'No Data': 'No Data',
    'Last 30 days': 'Last 30 days',
    'Last 6 months': 'Last 6 months',
    'Last year': 'Last year',
    'Results for': 'Results for',
    'Full Screen': 'Full Screen',
    Cut: 'Cut',
    Copy: 'Copy',
    'Card actions': 'Card actions',
    'Card cut — tap an empty slot to paste':
      'Card cut — tap an empty slot to paste',
    'Copied — tap an empty slot to paste':
      'Copied — tap an empty slot to paste',
    Shared: 'Shared',
    'Copied to clipboard': 'Copied to clipboard',
    'Share not available on this device':
      'Share is not available on this device',
    'Could not share': 'Could not share',
    'Download started': 'Download started',
    'Card removed': 'Card removed',
    'Cards removed': 'Cards removed',
    'Cards cut — tap an empty slot to paste':
      'Cards cut — tap an empty slot to paste',
    'Added to bar': 'Added to bar',
    'Removed from bar': 'Removed from bar',
    'Add to fixed bar': 'Add to fixed bar',
    'Add Item': 'Add Item',
    selected: 'selected',
    'Multi-select actions': 'Multi-select actions',
    'Cards cut — navigate and paste into empty slots':
      'Cards cut — navigate and paste into empty slots',
    'No empty slots to paste into': 'No empty slots to paste into',
    'Cards pasted': 'Cards pasted',
    'cards still to paste': 'cards still to paste',
    'ready to paste': 'ready to paste',
    'Paste actions': 'Paste actions',
    'Cards grouped into folder': 'Cards grouped into folder',
    'Select at least 2 cards to group': 'Select at least 2 cards to group',
    'New folder': 'New folder',
    'Subitems of': 'Subitems of',
    'Click above to return to parent': 'Click above to return to parent',
    'Add items and subitems!': 'Add items and subitems!',
    'You can drag items up': 'You can drag items up',
    'and move to another folder': 'and move to another folder',
    Pasted: 'Pasted',
    Paste: 'Paste',
    'Paste Inside': 'Paste Inside',
    Dark: 'Dark mode',
    Light: 'Light mode',
    'Card Properties': 'Card Properties',
    'Export PDF': 'Export PDF',
    'Export as PDF': 'Export as PDF',
    'Export section layout': 'Layout',
    'Export section content': 'Content',
    'Standard layout (grid)': 'Standard layout (grid)',
    'Single card (1×1 full page)': 'Single card (1×1 full page)',
    'Select card to export': 'Select card to export',
    'Select a card': 'Select a card',
    'Current board (grid)': 'Current board (grid)',
    'Fixed bar only': 'Fixed bar only',
    'Board + Fixed bar': 'Board + Fixed bar',
    'Main Board': 'Main Board',
    Part: 'Part',
    'Cut here': 'Cut here',
    'Exported on': 'Exported on',
    'Fixed Bar': 'Fixed Bar',
    'Cut for continuous use': 'Cut for continuous use',
    'Audio / Video': 'Audio / Video',
    'Add an audio or video': 'Add an audio or video',
    'Uploaded image': 'Uploaded image',
    'On touching this board show this image, if none set it will skip the action':
      'On touching this board show this image, if none set it will skip the action',
    'Search an image': 'Search an image',
    Suggestions: 'Suggestions',
    Images: 'Images',
    Publication: 'Publication',
    'Manage Boards': 'Manage Boards',
    'Livox Web': 'Livox Web',
    'Settings - Display': 'Settings - Display',
    Start: 'Start',
    Settings: 'Settings',
    'Manage Users': 'Manage Users',
    Voice: 'Voice',
    Controls: 'Controls',
    'Artificial Inteligence': 'Artificial Inteligence',
    About: 'About',
    Test: 'Test',
    'Voice Language': 'Voice Language',
    'Voice Actor': 'Voice Actor',
    'Voice speed': 'Voice speed',
    'Pitch Rate': 'Pitch Rate',
    Preview: 'Preview',
    'Quick chat': 'Quick chat',
    'Font Size': 'Font Size',
    'Paging Mode': 'Paging Mode',
    'Touch correction': 'Touch correction',
    'Time to wait between touches': 'Time to wait between touches',
    'Manually set time to prevent any further touches. Set zero seconds to disable.':
      'Manually set time to prevent any further touches. Set zero seconds to disable.',
    'Natural Conversation': 'Natural Conversation',
    'Trigger words': 'Trigger words',
    'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.':
      'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.',
    'No keywords created': 'No keywords created',
    'Speak navigation arrows': 'Speak navigation arrows',
    'Enable natural conversation': 'Enable natural conversation',
    'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet conection.':
      'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet conection.',
    'Enable Intellitouch': 'Enable Intellitouch',
    'Recommended for users with motor disabilities. Automatically detects impefect touches.':
      'Recommended for users with motor disabilities. Automatically detects imperfect touches.',
    'Delay will be set dynamically by Intellitouch.':
      'Delay will be set dynamically by Intellitouch.',
    Legacy: 'Legacy',
    'Livox5+': 'Livox 5.0+',
    'Licenses Status': 'Licenses Status',
    'Activity days': 'Activity',
    'Active Usage Status': 'Active Usage Status',
    'Above Average': 'Above Average',
    'Below Average': 'Below Average',
    'Average Interactions': 'Average Interactions: {{clicks}} clicks.',
    'Inactive licenses are those in which no user has used Livox in the given period.':
      'Inactive licenses are those in which no user has used Livox in the given period.',
    'Version Status': 'Version Status',
    'Devices with older Operating System (OS) versions are at risk of losing access to Livox.':
      'Devices with older Operating System (OS) versions are at risk of losing access to Livox.',
    'Outdated OS': 'Outdated OS',
    'Outdated Livox': 'Outdated Livox',
    'Operational System Version': 'Operational System Version',
    'Device usage (%)': 'Device usage (%)',
    'Device usage': 'Device usage',
    'Disability distribution': 'Disability distribution',
    Period: 'Period',
    '30 days': '30 days',
    '45 days': '45 days',
    '2 months': '2 months',
    '6 months': '6 months',
    '1 year': '1 year',
    'Global Active Usage': 'Global Active Usage',
    'Percent of the users that used above and below global average ({{clicks}} clicks).':
      'Percent of the users that used above and below global average ({{clicks}} clicks).',
    'Most Active': 'Most Active',
    'Least Active': 'Least Active',
    'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).':
      'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).',
    'Active users are those that had at least 1 interaction on the time period.':
      'Active users are those that had at least 1 interaction on the time period.',
    Activity: 'Activity',
    'License Activity': 'License Activity',
    'Active Licenses': 'Active Licenses',
    'Inactive Licenses': 'Inactive Licenses',
    'User Activity': 'User Activity',
    'Activity Summary': 'Activity Summary',
    'Dashboard Charts': 'Dashboard Charts',
    'Users per disability': 'Users per disability',
    'Users per age': 'Users per age',
    Autism: 'Autism',
    'Amyotrophic Lateral Sclerosis': 'Amyotrophic Lateral Sclerosis',
    'Cerebral Palsy': 'Cerebral Palsy',
    'Person without disabilities': 'Person without disabilities',
    'No physical disabilities, just unable to speak':
      'No physical disabilities, just unable to speak',
    'Stroke Sequelae': 'Stroke Sequelae',
    'Down Syndrome': 'Down Syndrome',
    'Brain Injury': 'Brain Injury',
    'Another motor impairment': 'Another motor impairment',
    'Another cognitive impairment': 'Another cognitive impairment',
    'Store Statistics': 'Store Statistics',
    Creators: 'Creators',
    Published: 'Published',
    'Unique Downloads': 'Unique Downloads',
    Items: 'Items',
    'SymbolStyx usage': 'SymbolStyx usage',
    'Uploaded Images': 'Uploaded Images',
    'Uploaded Audio/Video': 'Uploaded Audio/Video',
    'Multiple images': 'Multiple images',
    'Most used symbols': 'Most used symbols',
    'Usage Status': 'Usage Status',
    Disclaimer: 'Disclaimer',
    'basic plan disclaimer':
      'The BASIC license is a simpler version of Livox, with <b>less resources</b> and <b>no technical support</b>. Usually acquired by parents that know Livox well enough and, for instance, wish for a second device with less resources for their children to use outdoors.<br/>This version is not recommended for people starting using Livox, it’s recommended for who already have a PLUS version and want the BASIC for a second device.',
    'New state': 'New state',
    States: 'States',
    'Available Licenses': 'Available Licenses',
    'Unable to log in with provided credentials.':
      'It is not possible to log in with the information provided. Incorrect mail and/or password(s).',
    'Renew Licenses': 'Renew Licenses',
    'It is not possible to access cards with more than one state':
      'It is not possible to access cards with more than one state',
    'Only text': 'Only text',
    'Livox IntelliBar (Beta)': 'Livox IntelliBar (Beta)',
    'Print navigation card': 'Print navigation card',
    'Board + IntelliBar': 'Board + IntelliBar',
    'AI Error': 'AI Error',
    'Create items using AI!': 'Create items using AI!',
    'Get cards recommendations for every situation!':
      'Get cards recommendations for every situation!',
    'Examples:': 'Examples',
    'Breakfast items': 'Breakfast items',
    'Teeth brushing steps': 'Teeth brushing steps',
    'Quiz option choices': 'Quiz option choices',
    'and many more!': 'and many more!',
    'Cards suggestion with AI': 'Cards suggestion with AI',
    '{{used}} of {{limit}} used': '{{used}} of {{limit}} used',
    'Insufficient JandaIA coins': 'Insufficient JandaIA coins',
    'Type a topic': 'Type a topic',
    'Add card': 'Add card',
    'Card added to board': 'Card added to board',
    'No empty slots available': 'No empty slots available',
    'Failed to add card': 'Failed to add card',
    'Print all pages': 'Print all pages',
    "Are you sure you want to delete the card(s)? This can't be undone!":
      "Are you sure you want to delete the card(s)? This can't be undone!",
    'Edit Email': 'Edit Email',
    'Already exists an user with informed email':
      'Already exists an user with informed email',
    'Default Payment': 'Default Payment',
    'ending with': 'ending with',
    'Expires at': 'Expires at',
    'Plan details': 'Plan details',
    "Passwords don't match": "Passwords don't match",
    'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters':
      'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters',
    'User Already exists': 'User Already exists',
    'An email will be sent to activate the account':
      'An email will be sent to activate the account.',
    'Expire month': 'Expire month',
    'Expire year': 'Expire year',
    'Select as default payment method': 'Select as default payment method',
    'Change Billing': 'Change Billing',
    'Change card details': 'Change card details',
    activate_license: 'Ativate License',
    'Change Livox Plan': 'Change Livox Plan',
    'Due next in': 'Due next in',
    'Cancel motive': 'Cancel motive',
    'Are you sure you want to cancel the plan?':
      'Are you sure you want to cancel the plan?',
    Card: 'Card',
    'My subscriptions': 'My subscriptions',
    Cards: 'Cards',
    'Welcome to Livox': 'Welcome to Livox',
    'enter your e-mail address': 'enter your e-mail address',
    'enter your password': 'enter your password',
    'Password requirements': 'Password requirements',
    'Must be at least 8 characters long': 'Must be at least 8 characters long',
    'Must include at least one uppercase letter':
      'Must include at least one uppercase letter',
    'Must include at least one lowercase letter':
      'Must include at least one lowercase letter',
    'Must include at least one number': 'Must include at least one number',
    'Must include at least one special character':
      'Must include at least one special character',
    'Old Password': 'Old Password',
    'New Password': 'New Password',
    'enter your old password': 'enter your old password',
    'enter your new password': 'enter your new password',
    'confirm your new password': 'confirm your new password',
    'Holder Information': 'Holder Information',
    Client: 'Client',
    'My Subscriptions': 'My Subscriptions',
    'Payment Methods': 'Payment Methods',
    'Payment History': 'Payment History',
    'Livox Cloud': 'Livox Cloud',
    'of 1TB used': 'of 1TB used',
    'Portal Livox': 'Portal Livox',
    'CONGRATS!': 'CONGRATS!',
    'Based on your stats you used your account':
      'Based on your stats you used your account',
    'more than last month!': 'more than last month!',
    'Regional Food': 'Regional Food',
    Animals: 'Animals',
    'The Flash Game': 'The Flash Game',
    'All users': 'All users',
    'All period': 'All period',
    'Last day': 'Last day',
    'Last week': 'Last week',
    'Last month': 'Last month',
    '1 month': '1 month',
    'User Stats': 'User Stats',
    'Play Games': 'Play Games',
    'Play Duration': 'Play Duration',
    '(minutes)': '(minutes)',
    Recommendations: 'Recommendations',
    'Shared Content': 'Shared Content',
    'Total number of minutes:': 'Total number of minutes:',
    'Yes or No': 'Yes or No',
    Fruits: 'Fruits',
    Food: 'Food',
    'Monthly Usage': 'Monthly Usage',
    'Amount of Interactions': 'Amount of Interactions',
    "Oops! It looks like you haven't shared any content yet.":
      "Oops! It looks like you haven't shared any content yet.",
    'Edit Your Profile': 'Edit Your Profile',
    Appearance: 'Appearance',
    'Privacy Terms': 'Privacy Terms',
    'Service Terms': 'Service Terms',
    'Password Settings': 'Password Settings',
    'For up to 3 users who already know or follow up with Livox professionals.':
      'For up to 3 users who already know or follow up with Livox professionals.',
    '/MONTH': '/MONTH',
    'Payment Method': 'Payment Method',
    IntelliTouch: 'IntelliTouch',
    'Image Dataset': 'Image Dataset',
    'Current Plan': 'Current Plan',
    'Other Subscriptions': 'Other Subscriptions',
    'BASIC SUBSCRIPTION': 'BASIC SUBSCRIPTION',
    'Basic Subscription': 'Basic Subscription',
    'See as list': 'See as list',
    'See as grid': 'See as grid',
    'HOW IT WORKS?': 'HOW IT WORKS?',
    '.zip upload': '.zip upload',
    'create board': 'create board',
    create: 'create',
    upload: 'upload',
    feedback: 'feedback',
    'To get started, use Livox Studio to create cards, upload images, music and videos!':
      'To get started, use Livox Studio to create cards, upload images, music and videos!',
    'Submit you content to be published in the portal!':
      'Submit you content to be published in the portal!',
    'Receive feedback and satisfaction ratings knowing your boards are being used around the world!':
      'Receive feedback and satisfaction ratings knowing your boards are being used around the world!',
    Price: 'Price',
    OK: 'OK',
    PENDING: 'PENDING',
    DECLINED: 'DECLINED',
    CHANGE: 'CHANGE',
    paid: 'paid',
    open: 'open',
    draft: 'draft',
    void: 'void',
    declined: 'declined',
    uncollectible: 'uncollectible',
    Invoices: 'Invoices',
    'Wrong password.': 'Wrong old password.',
    "The two password fields didn't match.":
      'The two new passwords are not the same.',
    'Something went wrong.': 'Something went wrong.',
    'Please fill in all required fields.':
      'Please fill in all required fields.',
    'Password changed successfully!': 'Password changed successfully!',
    'Device Nickname': 'Device Nickname',
    'License Information': 'License Information',
    to: 'to',
    'Licenses per page': 'Licenses per page',
    'Published Content': 'Published Content',
    'View published content in the store':
      'View published content in the store',
    'Device removed successfully': 'Device removed successfully',
    'Failed to remove device': 'Failed to remove device',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    'Evolution of use': 'Evolution of use',
    'Use by schedule': 'Use by schedule',
    '(clicks)': '(clicks)',
    Responsible: 'Responsible',
    Birthday: 'Birthday',
    Birthdate: 'Birthdate',
    None: 'None',
    Mild: 'Mild',
    Moderate: 'Moderate',
    'Severe (Blindness)': 'Severe (Blindness)',
    Good: 'Good',
    'Severe (Needs switch)': 'Severe (Needs switch)',
    'Few physical limitations': 'Few physical limitations',
    'Difficulties in daily activities, requires assistance':
      'Difficulties in daily activities, requires assistance',
    'Almost or totally dependent': 'Almost or totally dependent',
    'Without communicative intent': 'Without communicative intent',
    'Does not verbalize, but has communicative intention':
      'Does not verbalize, but has communicative intention',
    'Make ounds': 'Make sounds',
    'Makes vowel unions': 'Makes vowel unions',
    'Speak with very limited vocabulary (5-10 words)':
      'Speak with very limited vocabulary (5-10 words)',
    'Speak with limited vocabulary (10-30 words)':
      'Speak with limited vocabulary (10-30 words)',
    'Fully communicative': 'Fully communicative',
    'Diagnosis Information': 'Diagnosis Information',
    'Fine motor skills': 'Fine motor skills',
    'Repetitive movements': 'Repetitive movements',
    'Hearing impairment': 'Hearing impairment',
    'Visual impairment': 'Visual impairment',
    'Current communication': 'Current communication',
    'Autonomy level': 'Autonomy level',
    Have: 'Have',
    'Does not have': 'Does not have',
    Yes: 'Yes',
    No: 'No',
    'Customer Admin': 'Customer Admin',
    'Portal Admin': 'Portal Admin',
    'Users per page': 'Users per page',
    Private: 'Private',
    Organization: 'Organization',
    'License Usage': 'License Usage',
    'Livox Usage': 'Livox Usage',
    Amount: 'Amount',
    Used: 'Used',
    'Users Status': 'Users Status',
    'active users': 'active users',
    Disability: 'Disability',
    'Portal Users': 'Portal Users',
    'Last Validation': 'Last Validation',
    Subscriptions: 'Subscriptions',
    'Public?': 'Public?',
    'Avaiable?': 'Avaiable?',
    'Searching for boards from all your users':
      'Searching for boards from all your users',
    'Your filters did not find results': 'Your filters did not find results',
    'not found': 'not found',
    "It looks like your users haven't created boards yet":
      "It looks like your users haven't created boards yet",
    'no boards': 'no boards',
    'Searching for your boards': 'Searching for your boards',
    'Find boards created by users in your organization here':
      'Find boards created by users in your organization here',
    'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?':
      'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?':
      'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?',
    '{{count}} devices removed successfully':
      '{{count}} devices removed successfully',
    '{{count}} devices failed to be removed':
      '{{count}} devices failed to be removed',
    'Branch removed successfully': 'Branch removed successfully',
    'Failed to remove branch': 'Failed to remove branch',
    'Branches moved successfully': 'Branches moved successfully',
    'Failed to move branches': 'Failed to move branches',
    'Move branches to:': 'Move branches to:',
    Move: 'Move',
    'Some selected branches have sub-branches. All sub-branches will also be moved.':
      'Some selected branches have sub-branches. All sub-branches will also be moved.',
    'Parent Branch': 'Parent Branch',
    Root: 'Root',
    'Sub-branch of': 'Sub-branch of',
    'Branch created successfully!': 'Branch created successfully!',
    'Email already registered': 'Email already registered',
    'Branch updated successfully': 'Branch updated successfully',
    'Create Branch': 'Create Branch',
    'Update Branch': 'Update Branch',
    'Edit Publication': 'Edit Publication',
    'My Assessments': 'My Assessments',
    'Assessments Details': 'Assessments Details',
    Assessment: 'Assessment',
    'Assessments per page': 'Assessments per page',
    Finish: 'Finish',
    'General assessment': 'General assessment',
    'Temporal assessment': 'Temporal assessment',
    'Assessment average': 'Assessment average',
    Cognitive: 'Cognitive',
    Auditory: 'Auditory',
    Visual: 'Visual',
    Oral: 'Oral',
    Behaviour: 'Behaviour',
    Geral: 'General',
    'Add comment': 'Add comment',
    'Enter your comment for this assessment':
      'Enter your comment for this assessment',
    'Assessment added successfully!': 'Assessment added successfully!',
    'Failed to add assessments': 'Failed to add assessments',
    'New assessment': 'New assessment',
    'Customer Support': 'Customer Support',
    Promoted: 'Promoted',
    Statistics: 'Statistics',
    Details: 'Details',
    Refuse: 'Refuse',
    Approve: 'Approve',
    'Content Details': 'Content Details',
    'boards per page': 'boards per page',
    'Searching for pending content...': 'Searching for pending content...',
    'Searching for promoted content...': 'Searching for promoted content...',
    'Searching for published content...': 'Searching for published content...',
    Created: 'Created',
    Demote: 'Demote',
    'Demote Publication': 'Demote Publication',
    'Do you want to demote this content?':
      'Do you want to demote this content?',
    'Approve Publication': 'Approve Publication',
    'Do you approve this publication?': 'Do you approve this publication?',
    'Original language': 'Original language',
    'Translate into (optional)': 'Translate into (optional)',
    'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.':
      'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.',
    'Reject Publication': 'Reject Publication',
    'Enter the comment for this rejection':
      'Enter the comment for this rejection',
    'Remove Publication': 'Remove Publication',
    'Download count': 'Download count',
    'Successfully promoted!': 'Successfully promoted!',
    'An error occurred while promoting.': 'An error occurred while promoting.',
    'Upload a banner to promote this board.':
      'Upload a banner to promote this board.',
    'Successfully published board!': 'Successfully published board!',
    'Successfully updated board!!': 'Successfully updated board!!',
    'An error occurred while submitting.':
      'An error occurred while submitting.',
    'Increase the description to at least 10 characters.':
      'Increase the description to at least 10 characters.',
    'Publish board': 'Publish board',
    'Board submitted for review!': 'Board submitted for review!',
    'Please upload a cover image.': 'Please upload a cover image.',
    'The board will be reviewed by an administrator before it appears in the store.':
      'The board will be reviewed by an administrator before it appears in the store.',
    'Enter description': 'Enter description',
    'Enter title': 'Enter title',
    'Enter subtitle': 'Enter subtitle',
    Subtitle: 'Subtitle',
    'Email successfully sent!!!': 'Email successfully sent!!!',
    'Error sending email!': 'Error sending email!',
    'The content has been demoted!': 'The content has been demoted!',
    'Failed to demote content!': 'Failed to demote content!',
    'Publication successfully approved!': 'Publication successfully approved!',
    'Failed to approve!': 'Failed to approve!',
    'Publication successfully rejected!': 'Publication successfully rejected!',
    'Failed to reject!': 'Failed to reject!',
    'Removing this sponsor will revoke acess to the dashboard and clear all licenses assigned to them.':
      'Removing this sponsor will revoke acess to the dashboard and clear all licenses assigned to them.',
    'Are you sure you want to delete this sponsor?':
      'Are you sure you want to delete this sponsor?',
    'The sponsor has been deleted!': 'The sponsor has been deleted!',
    'Failed to remove sponsor!': 'Failed to remove sponsor!',
    'Sponsor created successfully!': 'Sponsor created successfully!',
    'Sponsor updated successfully!': 'Sponsor updated successfully!',
    'Edit Sponsor': 'Edit Sponsor',
    'Create Sponsor': 'Create Sponsor',
    'enter sponsor name...': 'Enter sponsor name...',
    'enter email...': 'enter email...',
    'New Sponsor': 'New Sponsor',
    Sponsors: 'Sponsors',
    'Projects Details': 'Projects Details',
    'Project Dashboard': 'Project Dashboard',
    'Sponsors per page': 'Sponsors per page',
    '{{count}} licenses successfully assigned':
      '{{count}} licenses successfully assigned',
    'Failed to assign licenses': 'Failed to assign licenses',
    'Assign licenses to sponsor': 'Assign licenses to sponsor',
    'Assign Licenses': 'Assign Licenses',
    'Sponsor Licenses': 'Sponsor Licenses',
    'Sponsored Projects': 'Sponsored Projects',
    'Remove Licenses': 'Remove Licenses',
    'Remove licenses from sponsor': 'Remove licenses from sponsor',
    '{{count}} licenses successfully removed':
      '{{count}} licenses successfully removed',
    'Failed to remove licenses': 'Failed to remove licenses',
    'Create Portal User': 'Create Portal User',
    'enter first name...': 'enter first name...',
    'enter last name...': 'enter last name...',
    'enter a password...': 'enter a password...',
    'You do not have active plans': 'You do not have active plans',
    'You do not have canceled plans': 'You do not have canceled plans',
    'searching for your payment methods': 'searching for your payment methods',
    'You have no payment methods': 'You have no payment methods',
    failed: 'failed',
    'Your token is invalid or has expired':
      'Your token is invalid or has expired',
    'Password does not meet the minimum security requirements':
      'Password does not meet the minimum security requirements',
    'Passwords do not match.': 'Passwords do not match.',
    'Resetting...': 'Resetting...',
    'validating your token': 'validating your token',
    'Password successfully changed!': 'Password successfully changed!',
    'Error changing password!': 'Error changing password!',
    'enter branch name': 'enter branch name',
    'enter branch address': 'enter branch address',
    'enter customer name': 'enter customer name',
    'enter customer address': 'enter customer address',
    'enter city': 'enter city',
    'enter zip code': 'enter zip code',
    'enter state': 'enter state',
    'enter phone number': 'enter phone number',
    'Unauthorized Access': 'Unauthorized Access',
    'You do not have permission to view this page with your current role.':
      'You do not have permission to view this page with your current role.',
    'Page Not Found': 'Page Not Found',
    'Sorry, the page you are looking for doesn’t exist.':
      'Sorry, the page you are looking for doesn’t exist.',
    'Este campo não pode ser em branco.': 'This field cannot be blank.',
    'no licenses': 'no licenses',
    'You do not have any licenses available.':
      'You do not have any licenses available.',
    'Unit manager': 'Unit manager',
    'type to search': 'type to search',
    'Create user': 'Create user',
    'Manager e-mail': 'Manager e-mail',
    'enter password': 'enter password',
    'confirm password': 'confirm password',
    'Cancel user creation': 'Cancel user creation',
    'Select existing user': 'Select existing user',
    'Select a manager or create a new user':
      'Select a manager or create a new user',
    'Email not found. Click Create user': 'Email not found. Click Create user',
    'This email already exists. Select an existing user':
      'This email already exists. Select an existing user',
    'Customer email already registered.': 'Customer email already registered.',
    'Email is required': 'Email is required',
    'Branch updated successfully!': 'Branch updated successfully!',
    'Invalid value': 'Invalid value',
    'This field is required': 'This field is required',
    'Password is required': 'Password is required',
    licenses: 'licenses',
    users: 'users',
    Quantity: 'Quantity',
    Indicator: 'Indicator',
    Value: 'Value',
    Category: 'Category',
    Aggregate: 'Aggregate',
    'Customers per page': 'Customers per page',
    'Holders per page': 'Holders per page',
    'Searching for your licenses': 'Searching for your licenses',
    'There are no promoted boards': 'There are no promoted boards',
    'There are no pending boards': 'There are no pending boards',
    'No data was found for this chart.': 'No data was found for this chart.',
    Sponsor: 'Sponsor',
    'My Projects': 'My Projects',
    'Invalid Date': 'Data Inválida',
    'Organization Details': 'Organization Details',
    'All Licenses': 'All Licenses',
    'All License Types': 'All License Types',
    'Select Branch': 'Select Branch',
    'Unlink Licenses': 'Unlink Licenses',
    'Unlink License': 'Unlink License',
    'Licenses transferred with success!': 'Licenses transferred with success!',
    'Error in transfer!': 'Error in transfer!',
    'An unexpected error occurred!': 'An unexpected error occurred!',
    'Transfer licenses to:': 'Transfer licenses to:',
    'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.':
      'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.',
    'The Livox User has been deleted!': 'The Livox User has been deleted!',
    'Livox User updated successfully!': 'Livox User updated successfully!',
    'Edit Livox User': 'Edit Livox User',
    'Failed to remove Livox User!': 'Failed to remove Livox User!',
    'Delete Livox User': 'Delete Livox User',
    'Are you sure you want to delete this livox user?':
      'Are you sure you want to delete this livox user?',
    'Activate with QRCode': 'Activate with QRCode',
    'Enter a valid holder email': 'Enter a valid holder email',
    'To activate this license, enter the email of an associated holder.':
      'To activate this license, enter the email of an associated holder.',
    'Holder Email': 'Holder Email',
    'Invalid email or not associated with this license.':
      'Invalid email or not associated with this license.',
    Validate: 'Validate',
    'Activate with QRCode in your Livox app':
      'Activate with QRCode in your Livox app',
    Distributor: 'Distributor',
    'Distributor Admin': 'Distributor Admin',
    'Distributor Support': 'Distributor Support',
    'Create Support Area': 'Create Support Area',
    'enter support area name...': 'enter support area name...',
    'Support area created successfully!': 'Support area created successfully!',
    'Support area updated successfully!': 'Support area updated successfully!',
    'Edit Support Area': 'Edit Support Area',
    'Removing this support area will only unlink customers and users from this area.':
      'Removing this support area will only unlink customers and users from this area.',
    'Are you sure you want to delete this support area?':
      'Are you sure you want to delete this support area?',
    'The support area has been deleted!': 'The support area has been deleted!',
    'Failed to remove support area!': 'Failed to remove support area!',
    'Support Area Users': 'Support Area Users',
    'Remove Users': 'Remove Users',
    'Remove users from support area': 'Remove users from support area',
    'Failed to remove users': 'Failed to remove users',
    'Select Users': 'Select Users',
    '{{count}} users successfully removed':
      '{{count}} users successfully removed',
    'Support Area Customers': 'Support Area Customers',
    'Select Customers': 'Select Customers',
    'Customers added successfully!': 'Customers added successfully!',
    'Remove Customers': 'Remove Customers',
    '{{count}} customers successfully removed':
      '{{count}} customers successfully removed',
    'Failed to remove customers': 'Failed to remove customers',
    'Remove customers from support area': 'Remove customers from support area',
    Add: 'Add',
    'Support Areas per page': 'Support Areas per page',
    'Created at': 'Created at',
    'Confirm delete': 'Confirm delete',
    'Android Versions': 'Android Versions',
    'Create Android Version': 'Create Android Version',
    'Edit Android Version': 'Edit Android Version',
    'New Android Version': 'New Android Version',
    'Android version created successfully!':
      'Android version created successfully!',
    'Android version updated successfully!':
      'Android version updated successfully!',
    'The android version has been deleted!':
      'The android version has been deleted!',
    'Failed to remove android version!': 'Failed to remove android version!',
    'Are you sure you want to delete this android version?':
      'Are you sure you want to delete this android version?',
    'Android Versions per page': 'Android Versions per page',
    Resellers: 'Resellers',
    'Create Reseller': 'Create Reseller',
    'Edit Reseller': 'Edit Reseller',
    'New Reseller': 'New Reseller',
    'enter reseller name...': 'enter reseller name...',
    'Reseller created successfully!': 'Reseller created successfully!',
    'Reseller updated successfully!': 'Reseller updated successfully!',
    'The reseller has been deleted!': 'The reseller has been deleted!',
    'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.':
      'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.',
    'Are you sure you want to delete this reseller?':
      'Are you sure you want to delete this reseller?',
    'Resellers per page': 'Resellers per page',
    'Payment QR Code': 'Payment QR Code',
    'Payment link for {{name}}': 'Payment link for {{name}}',
    'Payment link': 'Payment link',
    UUID: 'UUID',
    'User created successfully!': 'User created successfully!',
    Spanish: 'Spanish',
    'Billing user does not exist': 'Billing user does not exist',
    French: 'French',
    Italian: 'Italian',
    'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.':
      'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.',
    "Don't show again": "Don't show again",
    'Website Update': 'Website Update',
    'Reload page': 'Reload page',
    'enter email': 'enter email',
    'Customer created successfully!': 'Customer created successfully!',
    'Enter a valid email address': 'Enter a valid email address',
    'Only letters are allowed': 'Only letters are allowed',
    'enter number of devices': 'enter number of devices',
    'enter text': 'enter text',
    'enter install key...': 'enter install key...',
    'enter device name...': 'enter device name...',
    'enter device nickname...': 'enter device nickname...',
    'enter device MAC address...': 'enter device MAC address...',
    'Device MAC Address': 'Device MAC Address',
    'Licenses created successfully!': 'Licenses created successfully!',
    Payment: 'Payment',
    'Registration link generated successfully!':
      'Registration link generated successfully!',
    'Failed to generate registration link.':
      'Failed to generate registration link.',
    'Copy Link': 'Copy Link',
    'Link copied to clipboard!': 'Link copied to clipboard!',
    '{{diff}} year(s) ago': '{{diff}} year(s) ago',
    '{{diff}} month(s) ago': '{{diff}} month(s) ago',
    '{{diff}} day(s) ago': '{{diff}} day(s) ago',
    '{{diff}} hour(s) ago': '{{diff}} hour(s) ago',
    '{{diff}} minute(s) ago': '{{diff}} minute(s) ago',
    'Holder registered successfully!': 'Holder registered successfully!',
    'Register Holder': 'Register Holder',
    'enter address': 'enter address',
    'confirm your password': 'confirm your password',
    'Passwords must match': 'Passwords must match',
    'Professional Type': 'Professional Type',
    'Speech Therapist': 'Speech Therapist',
    'Occupational Therapist': 'Occupational Therapist',
    Physiotherapist: 'Physiotherapist',
    Teacher: 'Teacher',
    Pedagogue: 'Pedagogue',
    Psychopedagogue: 'Psychopedagogue',
    Other: 'Other',
    'Error loading subscription details': 'Error loading subscription details',
    Activation: 'Activation',
    Cancellation: 'Cancellation',
    'Due Date': 'Due Date',
    'Payment Link': 'Payment Link',
    Receipt: 'Receipt',
    'View Receipt': 'View Receipt',
    'Invoice Date': 'Invoice Date',
    Paid: 'Paid',
    'Invoice Status': 'Invoice Status',
    'Receipt Link': 'Receipt Link',
    'Status updated successfully': 'Status updated successfully',
    'Failed to update license status': 'Failed to update license status',
    'Edit License': 'Edit License',
    'Are you sure you want to delete this license?':
      'Are you sure you want to delete this license?',
    'Are you sure you want to delete license':
      'Are you sure you want to delete license',
    'This will delete all licenses with install key: {{installKey}}':
      'This will delete all licenses with install key: {{installKey}}',
    'Permanently delete the license(s)': 'Permanently delete the license(s)',
    'License deleted successfully!': 'License deleted successfully!',
    'Failed to delete license!': 'Failed to delete license!',
    'License updated successfully!': 'License updated successfully!',
    'Failed to update license!': 'Failed to update license!',
    'No changes to save': 'No changes to save',
    'Are you sure you want to update all licenses?':
      'Are you sure you want to update all licenses?',
    'This will update all licenses with install key':
      'This will update all licenses with install key',
    'Update install key to': 'Update install key to',
    'Update type to': 'Update type to',
    'All licenses with this install key will be affected!':
      'All licenses with this install key will be affected!',
    'Click here': 'Click here',
    Donation: 'Donation',
    Sale: 'Sale',
    Evaluation: 'Evaluation',
    Research: 'Research',
    'Old Version (BETA TEST)': 'Old Version (BETA TEST)',
    Developer: 'Developer',
    Representative: 'Representative',
    'Resale Channel': 'Resale Channel',
    'Are you sure you want to unblock this customer?':
      'Are you sure you want to unblock this customer?',
    'Are you sure you want to block this customer?':
      'Are you sure you want to block this customer?',
    Block: 'Block',
    'Change Status': 'Change Status',
    'Are you sure you want to change the status?':
      'Are you sure you want to change the status?',
    Select: 'Select',
    'Confirm Exit': 'Confirm Exit',
    'Are you sure you want to exit? Any unsaved changes will be lost.':
      'Are you sure you want to exit? Any unsaved changes will be lost.',
    Export: 'Export',
    'Export Charts': 'Export Charts',
    'Export Charts to PDF': 'Export Charts to PDF',
    'Export Data': 'Export Data',
    'Exporting...': 'Exporting...',
    'No data to export': 'No data to export',
    'No charts found to export': 'No charts found to export',
    'File exported successfully': 'File exported successfully',
    'Charts exported successfully': 'Charts exported successfully',
    'Export successful!': 'Export successful!',
    'Export failed!': 'Export failed!',
    'Error exporting file': 'Error exporting file',
    'Error exporting charts': 'Error exporting charts',
    Update: 'Update',
    'Are you sure you want to delete this user?':
      'Are you sure you want to delete this user?',
    'Are you sure you want to delete user':
      'Are you sure you want to delete user',
    'This action will:': 'This action will:',
    'Unlink all licenses from the user holder':
      'Unlink all licenses from the user holder',
    'Delete the associated holder (if exists)':
      'Delete the associated holder (if exists)',
    'Remove user from all groups': 'Remove user from all groups',
    'Delete all Livox Users linked to this user':
      'Delete all Livox Users linked to this user',
    'Permanently delete the user account':
      'Permanently delete the user account',
    'This action cannot be undone!': 'This action cannot be undone!',
    'User updated successfully!': 'User updated successfully!',
    'User deleted successfully!': 'User deleted successfully!',
    '{{count}} licenses unlinked.': '{{count}} licenses unlinked.',
    'Holder deleted.': 'Holder deleted.',
    'Failed to delete user!': 'Failed to delete user!',
    'Changing password for user': 'Changing password for user',
    'enter new password...': 'enter new password...',
    'confirm new password...': 'confirm new password...',
    'Update Password': 'Update Password',
    'Password updated successfully!': 'Password updated successfully!',
    'confirm your password...': 'confirm your password...',
    'Edit Portal User': 'Edit Portal User',
    'User Details': 'User Details',
    'Personal Data': 'Personal Data',
    'View Details': 'View Details',
    'View Holder Details': 'View Holder Details',
    'View Boards': 'View Boards',
    'View Content Store': 'View Content Store',
    'Created boards': 'Created boards',
    Total: 'Total',
    'Published boards': 'Published boards',
    'No holder linked': 'No holder linked',
    'No customer linked': 'No customer linked',
    'User Boards': 'User Boards',
    'View boards created by this user': 'View boards created by this user',
    'Customer not found': 'Customer not found',
    'Loading boards': 'Loading boards',
    "This user hasn't created any boards yet":
      "This user hasn't created any boards yet",
    'Create Holder': 'Create Holder',
    'Edit Holder': 'Edit Holder',
    'Holder created successfully!': 'Holder created successfully!',
    'No user found for this email. Fill in the fields below to create a new holder user.':
      'No user found for this email. Fill in the fields below to create a new holder user.',
    'Holder updated successfully!': 'Holder updated successfully!',
    'Holder deleted successfully!': 'Holder deleted successfully!',
    'Are you sure you want to delete this holder?':
      'Are you sure you want to delete this holder?',
    'Are you sure you want to delete holder':
      'Are you sure you want to delete holder',
    'Release all licenses from this holder':
      'Release all licenses from this holder',
    'Permanently delete the holder': 'Permanently delete the holder',
    '{{count}} licenses released.': '{{count}} licenses released.',
    'Failed to delete holder!': 'Failed to delete holder!',
    'User is required': 'User is required',
    'Country is required': 'Country is required',
    'Zipcode is required': 'Zipcode is required',
    'Phone number is required': 'Phone number is required',
    'enter zipcode...': 'enter zipcode...',
    'enter address...': 'enter address...',
    'enter city...': 'enter city...',
    'enter state...': 'enter state...',
    'enter phone number...': 'enter phone number...',
    'enter professional record...': 'enter professional record...',
    'Professional Record': 'Professional Record',
    'Holder Details': 'Holder Details',
    'Professional Information': 'Professional Information',
    'No licenses linked': 'No licenses linked',
    'Livox User Details': 'Livox User Details',
    'Personal Information': 'Personal Information',
    'Health Information': 'Health Information',
    'Contact Information': 'Contact Information',
    'Responsible Information': 'Responsible Information',
    'Responsible 1 Name': 'Responsible 1 Name',
    'Responsible 1 Email': 'Responsible 1 Email',
    'Responsible 1 Phone': 'Responsible 1 Phone',
    'Responsible 2 Name': 'Responsible 2 Name',
    'Responsible 2 Email': 'Responsible 2 Email',
    'Responsible 2 Phone': 'Responsible 2 Phone',
    'Autonomy Level': 'Autonomy Level',
    'Current Communication': 'Current Communication',
    'Visual Impairment': 'Visual Impairment',
    'Fine Motor Skills': 'Fine Motor Skills',
    'Repetitive Movements': 'Repetitive Movements',
    'Hearing Impairment': 'Hearing Impairment',
    'No data available': 'No data available',
    Unauthorized: 'Unauthorized',
    'Board settings': 'Board settings',
    'Board name and cover': 'Board name and cover',
    'Board name': 'Board name',
    'Board cover image': 'Board cover image',
    'Board cover': 'Board cover',
    'Click the image to change': 'Click the image to change',
    'Error uploading image': 'Error uploading image',
    'Error saving title': 'Error saving title',
    'Move cards': 'Move cards',
    'Select cards': 'Select cards',
    Redo: 'Redo',
    Help: 'Help',
    Layout: 'Layout',
    'Board background color': 'Board background color',
    'Card settings': 'Card settings',
    'Fixed bar settings': 'Fixed bar settings',
    'Lock board horizontal': 'Lock board horizontal',
    'Auto navigation cards': 'Auto navigation cards',
    back: 'back',
    Columns: 'Columns',
    'Select background color': 'Select background color',
    'General card settings': 'General card settings',
    'Show text only': 'Show text only',
    'Text position': 'Text position',
    Bottom: 'Bottom',
    Top: 'Top',
    'Show cards with levels as folders': 'Show cards with levels as folders',
    'High contrast cards': 'High contrast cards',
    'Black and white cards': 'Black and white cards',
    IntelliBar: 'IntelliBar',
    'Enable IntelliBar': 'Enable IntelliBar',
    'IntelliBar description':
      'When enabled, Livox will display a bar at the top of the screen where the user can create sentences. This feature requires downloading the conversation cards board, "IntelliBar", if you haven\'t already.',
    'IntelliBar screen size': 'IntelliBar screen size',
    'Speak card when adding to IntelliBar':
      'Speak card when adding to IntelliBar',
    Disabled: 'Disabled',
    Enabled: 'Enabled',
    'Partially enabled': 'Partially enabled',
    intelibar_speak_disabled_desc:
      'Livox will only speak when you tap the speak button in the IntelliBar.',
    intelibar_speak_partial_desc:
      'Livox will speak the clicked card that is inserted into the IntelliBar.',
    intelibar_speak_full_desc: 'Livox will speak every clicked card.',
    'Speak card before adding': 'Speak card before adding',
    'Speak card after adding': 'Speak card after adding',
    'Show only card text in IntelliBar': 'Show only card text in IntelliBar',
    'Enable fixed bar': 'Enable fixed bar',
    'Fixed bar scroll up': 'Scroll fixed bar up',
    'Fixed bar scroll down': 'Scroll fixed bar down',
    'Fixed bar scroll left': 'Scroll fixed bar left',
    'Fixed bar scroll right': 'Scroll fixed bar right',
    'Fixed bar limit reached': 'Fixed bar limit reached',
    Position: 'Position',
    Side: 'Side',
    'Visible cards count': 'Visible cards count',
    'Show as folder': 'Show as folder',
    'Select card bar color': 'Select card bar color',
    'Create a Card': 'Create a Card',
    Image: 'Image',
    'Text/Spoken text': 'Text/Spoken text',
    'Color Background': 'Color Background',
    'Add media': 'Add media',
    'Image Bank': 'Image Bank',
    'Artificial Intelligence': 'Artificial Intelligence',
    'Search image': 'Search image',
    'Starts with': 'Starts with',
    'Card title': 'Card title',
    'Spoken Text': 'Spoken Text',
    'Letters; Numbers': 'Letters; Numbers',
    'Text/Spoken Text': 'Text/Spoken Text',
    card_title_description: 'This text will be shown in the card.',
    'Spoken text': 'Spoken text',
    spoken_text_description:
      'This text will be read. You can write long texts if you want.',
    'Text font': 'Text font',
    'Text color': 'Text color',
    'Background Color': 'Background Color',
    'Background color card': 'Background color card',
    'Card border color': 'Card border color',
    'Attach a media': 'Attach a media',
    'No media': 'No media',
    'Record an audio': 'Record an audio',
    'Pick an audio': 'Pick an audio',
    'Pick a video': 'Pick a video',
    'Cards Properties': 'Cards Properties',
    'Show just text': 'Show just text',
    show_just_text_desc:
      'If enabled, Livox will no longer show cards with image',
    'Large size images': 'Large size images',
    large_images_desc: 'If enabled, cards will appear bigger',
    'Keep the card unchanged': 'Keep the card unchanged',
    keep_unchanged_desc:
      'This card will not undergo modifications on boards with values set as default',
    'Display card in folder format': 'Display card in folder format',
    'Card Title': 'Card Title',
    'Upload Card': 'Upload Card',
    'Board layout': 'Board layout',
    'Maintain relative positioning': 'Maintain relative positioning',
    help_move: 'Enable to drag and reorder cards on the board.',
    help_select: 'Enable to select multiple cards at once.',
    help_yesno: 'Enable to add Yes/No buttons on cards.',
    help_undo_redo: 'Undo or redo changes to settings.',
    help_play_mode:
      'Open the board in fullscreen and use it for real: navigate cards and folders, build phrases and hear them spoken.',
    help_export_pdf:
      'Export the current board as a PDF file to print or share.',
    help_ia: 'Use artificial intelligence to suggest cards automatically.',
    Interests: 'Interests',
    'Android ID': 'Android ID',
    'Advanced Filters': 'Advanced Filters',
    'Apply Filters': 'Apply Filters',
    'Clear All': 'Clear All',
    Order: 'Order',
    Ascending: 'Ascending',
    Descending: 'Descending',
    From: 'From',
    To: 'To',
    All: 'All',
    Information: 'Information',
    Location: 'Location',
    Keys: 'Keys',
    'Date of Birth': 'Date of Birth',
    'Activated Licenses': 'Activated Licenses',
    'Inactivated Licenses': 'Inactivated Licenses',
    Options: 'Options',
    Hide: 'Hide',
    Show: 'Show',
    'Enter sublevel': 'Enter sublevel',
    'Create folder': 'Create folder',
    'Edit Card': 'Edit Card',
    'Add state': 'Add state',
    'Cannot access cards with more than one state':
      'Cannot access cards with more than one state.',
    'Cards with sublevels cannot have multiple states':
      'Cards with sublevels cannot have multiple states.',
    Untitled: 'Untitled',
    'No states yet. Add one below.': 'No states yet. Add one below.',
    'Generate image': 'Generate image',
    'Enter image prompt...': 'Enter image prompt...',
    'Image style': 'Image style',
    'Download image': 'Download image',
    Contains: 'Contains',
    'Type to search symbols': 'Type to search symbols',
    'Save failed': 'Save failed',
    'Choose file from computer': 'Choose file from computer',
    Upload: 'Upload',
    'Upload failed': 'Upload failed',
    'Select from image bank': 'Select from image bank',
    'Generate with AI': 'Generate with AI',
    Generated: 'Generated',
    'Upload an image from your device': 'Upload an image from your device',
    'Choose a symbol from the image bank':
      'Choose a symbol from the image bank',
    Selected: 'Selected',
    'Unsaved image selected': 'Unsaved image selected',
    'Upload image from computer': 'Upload image from computer',
    'Select an image before saving the card.':
      'Select an image before saving the card.',
    'Book Settings': 'Book Settings',
    'Text size': 'Text size',
    'Highlight spoken text': 'Highlight spoken text',
    Exit: 'Exit',
    'Start over': 'Start from the beginning',
    'To enable Book Mode, add cards to the board':
      'To enable Book Mode, add cards to the board',
    'Deactivate Book Mode to create sublevels':
      'Deactivate Book Mode to create sublevels',
    'Continue from page {{page}}': 'Continue from page {{page}}',
    'Open at page {{page}}': 'Open at page {{page}}',
    'To enable Book Mode, add child cards':
      'To enable Book Mode, add child cards',
    'This book has no pages': 'This book has no pages',
  },
}
